// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__kjMUe","list":"MainNavigation_list__e-j1b","active":"MainNavigation_active__vD9tN"};